import React, {useMemo, useState} from 'react';
import {ErrorMessage, Field, Formik} from 'formik';
import {Input, Select} from '../../../../_metronic/_partials/controls';
import * as Yup from 'yup';
import {useDispatch} from 'react-redux';
import * as actions from '../../../modules/Collector/_redux/collectorAction';
import {useCollectorUIContext} from '../CollectorUIContext';
import {Modal} from 'react-bootstrap';
import {toastOption} from '../../../../_metronic/_helpers';
import {toast} from 'react-toastify'

// Validation schema
const validationSchema = Yup.object().shape({
    status: Yup.string().required('Status wajib diisi'),
    reason: Yup.string().when('status', {
        is: value => value === 'REJECT',
        then: Yup.string().required('Keterangan tidak boleh kosong'),
        otherwise: Yup.string(),
    }),
});

export const ConfirmForm = ({id, onHide}) => {

    const status = {
        batch_uuid: '',
        status: '',
        reason: '',
    };

    const dispatch = useDispatch();

    const [showReason, setShowReason] = useState(false);
    const changeConfirm = (e) => {
        let value = e.target.value;
        setShowReason(value === 'REJECT' ? true : false);
    };

    // Collector UI Context
    const collectorUIContext = useCollectorUIContext();
    const collectorUIProps = useMemo(() => {
        return {
            queryParams: collectorUIContext.queryParams,
        };
    }, [collectorUIContext]);

    const saveConfirm = (values) => {
        let data = {
            batch_uuid: id,
            status_collect: values.status,
            reason: values.reason,
        };
        dispatch(actions.updateStatusCollect(data)).then((response) => {
                toast.success(response.message, toastOption)
                dispatch(actions.fetchCollects(collectorUIProps.queryParams))
                onHide()
            }
        ).catch((err) => {
            toast.error('GAGAL', toastOption)
        });
    };

    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={status}
                validationSchema={validationSchema}
                onSubmit={(values) =>
                    saveConfirm(values)
                }
            >{({handleSubmit, handleChange, setFieldValue}) => (

                <>

                    <div className="form-group row">
                        <div className="col-lg-5">
                            <Select
                                name="status"
                                label="status"
                                onChange={(e) => {
                                    handleChange(e);
                                    changeConfirm(e);
                                    setFieldValue('reason', '');
                                }}
                            >
                                <option value="">--PILIH--</option>
                                <option value="APPROVED">APPROVED</option>
                                <option value="REJECT">REJECT</option>
                            </Select>
                            <ErrorMessage name='status'
                                          render={msg => <div style={{color: 'red'}}>{msg}</div>}/>
                        </div>

                        {showReason && (
                            <div className="col-lg-7">
                                <Field
                                    name="reason"
                                    component={Input}
                                    placeholder="Keterangan"
                                    label="keterangan"
                                />
                            </div>
                        )}
                    </div>

                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            className="btn btn-light btn-elevate"
                        >
                            Cancel
                        </button>
                        <> </>
                        <button
                            type="submit"
                            onClick={() => handleSubmit()}
                            className="btn btn-primary btn-elevate"
                        >
                            Confirm
                        </button>
                    </Modal.Footer>
                </>
            )}

            </Formik>
        </>
    );
};

